import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Copyright from '../../internals/components/Copyright';
import MarketingKitDisplay from './MarketingKitDisplay';

export default function MainGridMarketingKit({ category }) {
    return (
        <>
            <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, display: 'flex', flexDirection: 'column' }}>
                <Grid
                    container
                    spacing={2}
                    columns={12}
                    sx={{ mb: (theme) => theme.spacing(2), alignItems: 'center', justifyContent: 'center' }}
                >
                    <MarketingKitDisplay />
                </Grid>
                <Copyright sx={{ my: 4 }} />
            </Box>
        </>
    );

};